import { Module } from 'vuex'
import state from './state'
import * as getters from './getters'
import { actions } from './actions'
import * as mutations from './mutations'
import { RootState } from '../types'
import { AccountState } from './types'

const namespaced = true

export const account: Module<AccountState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
